module.exports = __webpack_public_path__ + "img/thieme.dc252ab5.png";